package es.subastia.data.mapper

import es.subastia.data.model.SavedSearchDataModel
import es.subastia.domain.model.AuctionProcedureType
import es.subastia.domain.model.AuctionTypeDomainModel
import es.subastia.domain.model.ProvinceDomainModel
import es.subastia.domain.model.SavedSearchModel

fun SavedSearchModel.toData(): SavedSearchDataModel {
    return SavedSearchDataModel(
        id = id,
        userId = userId,
        title = title,
        type = type?.text,
        procedureType = procedureType?.label,
        province = province?.nm,
        query = query,
        createdAt = createdAt.toDouble()
    )
}

fun SavedSearchDataModel.toDomain(): SavedSearchModel {
    return SavedSearchModel(
        id = id,
        userId = userId,
        title = title,
        type = type?.let { AuctionTypeDomainModel.fromString(it) },
        procedureType = procedureType?.let { AuctionProcedureType.fromString(it) },
        province = province?.let { ProvinceDomainModel.fromString(it) },
        query = query,
        createdAt = createdAt.toLong()
    )
}
